import { ReactNode } from 'react';

import { Typography, Box, Stack } from '@cast/design-system';

type SectionProps = {
  children: ReactNode;
};

export const WhatHappensNextSection = ({ children }: SectionProps) => (
  <Stack gap={2}>
    <Typography variant="P14M">What happens next?</Typography>
    <Box sx={{ my: 0, pl: 8 }}>{children}</Box>
  </Stack>
);

type BulletProps = {
  children: ReactNode;
};

export const WhatHappensNextBullet = ({ children }: BulletProps) => (
  <Typography variant="P12R" color="textSecondary">
    • {children}
  </Typography>
);
